(() => {
  const canvas = document.querySelector('[data-orbit-mist]');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  const header = canvas.closest('.om-header');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let width=1, height=1, raf=0, active=true, last=0, time=0, aim=0, lean=0;
  const place = () => {
    const h=header.getBoundingClientRect();
    width=Math.max(1,h.width); height=Math.max(1,h.height);
    canvas.style.left='0px';canvas.style.top='0px';
    canvas.style.width=`${width}px`;canvas.style.height=`${height}px`;
    const dpr=Math.min(devicePixelRatio||1,3);
    canvas.width=Math.round(width*dpr);canvas.height=Math.round(height*dpr);
    ctx.setTransform(dpr,0,0,dpr,0,0);
    draw(reduced.matches?12:time);
  };
  const smooth = n => { const v=Math.max(0,Math.min(1,n));return v*v*(3-2*v); };
  const hash = n => { const x=Math.sin(n*127.1+311.7)*43758.5453;return x-Math.floor(x); };
  function draw(t) {
    ctx.clearRect(0,0,width,height);
    if(width<40)return;
    const reveal=reduced.matches?1:smooth(t/1.5);
    ctx.globalAlpha=reveal;
    const count=width<700?1500:3200;
    const columns=Math.ceil(Math.sqrt(count*width/height));
    const rows=Math.ceil(count/columns);
    const dx=(width-12)/(columns-1),dy=(height-12)/(rows-1);
    ctx.strokeStyle='rgba(38,38,38,.10)';ctx.lineWidth=.45;ctx.beginPath();
    for(let col=0;col<columns;col++){const x=6+col*dx;ctx.moveTo(x,6);ctx.lineTo(x,height-6);}
    for(let row=0;row<rows;row++){const y=6+row*dy;ctx.moveTo(6,y);ctx.lineTo(width-6,y);}
    ctx.stroke();
    const cycle=Math.floor(t/72),phase=t%72-60;
    const blockColumns=Math.ceil(columns/2);
    for(let i=0;i<columns*rows;i++){
      const col=i%columns,row=Math.floor(i/columns);
      const blockCol=Math.floor(col/2),blockRow=Math.floor(row/2);
      const seed=blockRow*blockColumns+blockCol+cycle*7919;
      const eligible=hash(seed)<.18&&blockCol*2+1<columns&&blockRow*2+1<rows;
      const delay=hash(seed+43)*8, duration=1.2+hash(seed+97)*1.8;
      const travel=eligible&&!reduced.matches?smooth((phase-delay)/duration):0;
      const localX=col%2,localY=row%2;
      const clockwise=hash(seed+131)>.5;
      const targetX=clockwise?1-localY:localY;
      const targetY=clockwise?localX:1-localX;
      const x=6+(col+(targetX-localX)*travel)*dx;
      const y=6+(row+(targetY-localY)*travel)*dy;
      const moving=travel>0&&travel<1;
      const emphasis=moving?Math.sin(Math.PI*travel):0;
      ctx.fillStyle=`rgba(32,32,32,${.2+emphasis*.35})`;
      ctx.beginPath();ctx.arc(x,y,.58,0,Math.PI*2);ctx.fill();
    }
    ctx.globalAlpha=1;
  }
  let lastDrawCycle=-1;
  const frame = now => {
    raf=0;if(!active||document.hidden||reduced.matches)return;
    if(last)time+=Math.min((now-last)/1000,.05);last=now;
    lean+=(aim-lean)*.025;
    if(time<2||time%72>59.9||lastDrawCycle!==Math.floor(time/72)){draw(time);lastDrawCycle=Math.floor(time/72);}
    raf=requestAnimationFrame(frame);
  };
  const resume=()=>{if(!raf&&active&&!document.hidden&&!reduced.matches){last=0;raf=requestAnimationFrame(frame);}else if(reduced.matches)draw(12);};
  const observer=new IntersectionObserver(entries=>{active=entries[0].isIntersecting;if(!active){cancelAnimationFrame(raf);raf=0;}else resume();});
  observer.observe(header);
  const resize=new ResizeObserver(place);resize.observe(header);
  header.addEventListener('pointermove',e=>{const b=header.getBoundingClientRect();aim=(e.clientY-b.top)/b.height-.5;},{passive:true});
  header.addEventListener('pointerleave',()=>aim=0);
  document.addEventListener('visibilitychange',()=>{if(document.hidden){cancelAnimationFrame(raf);raf=0;}else resume();});
  reduced.addEventListener('change',()=>{cancelAnimationFrame(raf);raf=0;resume();});
  window.addEventListener('pagehide',()=>{cancelAnimationFrame(raf);raf=0;});
  window.addEventListener('pageshow',resume);
  document.fonts.ready.then(()=>{place();resume();});
})();
